import React from 'react'
import { Link } from 'react-router-dom'
import '../App.css'
import img1 from '../images/img1.png'
import img2 from '../images/img2.png'

const Home = () => {
  return (
    <>
      <section className="section1">
        <div className=" title52 bottom100">A Te che non Ti Arrendi mai, Perché Sai che la Vita ti Deve Ancora un Sogno</div>
        <div className="around-row">
          <div>
            <p className="text-center title24">Il mio trading</p>
            <Link to="/trading"><img src={img1} alt="" className="imgHome" />
            </Link>
          </div>
          <div>
            <p className="text-center title24">Il mio benessere</p>
            <img src={img2} alt="" className="imgHome" />
          </div>
        </div>
      </section>
    </>
  )
}

export default Home